import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { environment } from '../../../environments/environment.prod';
import { byPassJwToken } from './interceptor.service'
import { ActionResult } from 'src/app/models/auth/_models/action-result';
import { Favorite } from 'src/app/models/auth/_models/favorite';
import { ConfigService } from '../config.service';
import { MessagesService } from './messages.service';
import { AuthService } from 'src/app/models/auth/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService  {
  private updateFavorite$ = new Subject<void>();
  favorites$: BehaviorSubject<Favorite[]> = new BehaviorSubject<Favorite[]>(null);
  sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');

  httpOptions = {
    context: byPassJwToken()
  }

  codUser: string;

  @Output() favoriteEmitter = new EventEmitter<any>();
  @Output() favoriteDeletedEmitter = new EventEmitter<any>();
  @Output() programaOpheliaEmiter = new EventEmitter<any>();
  constructor( private http: HttpClient,private configService: ConfigService,private messagesService:MessagesService,private auth:AuthService) { 
        
    if(this.sessionData?.data)this.codUser = this.sessionData.data.user_info.datageneral.cod_usua;
  }
    


  getFavorites(companyCode:number) {
    this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/Favorites?companyCode=${companyCode}`).subscribe(resp => {
      let data: Favorite[] = [];
      if (resp.isSuccessful && resp.result != null) {
        for (let favoriteBd of resp.result) {
          let favorite: any = {
            aud_esta: favoriteBd.auD_ESTA,
            aud_ufac: favoriteBd.auD_UFAC,
            aud_usua: favoriteBd.auD_USUA,
            fav_cont: favoriteBd.faV_CONT,
            fav_maid: favoriteBd.faV_MAID,
            usu_codi: favoriteBd.usU_CODI,

          };
          data.push(favorite);
        }
      }

      this.favorites$.next(data);
    }, err => this.messagesService.error("Error cargando favoritos: No se puedo conectar con el servidor"))


  }
  addFavorite(favorite: Favorite) {
    this.http.post<ActionResult<string>>(`${this.configService.config.apiSecuritySeven}/Favorites`, favorite).subscribe(resp => {
      if (resp.isSuccessful) {
        this.messagesService.success('Favorito agregado');
        this.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
      }
      else
        this.messagesService.error(`Error agregando favorito: ${resp.errorMessage}`);
    }, err => this.messagesService.error(`Error agregando favorito: No se puedo conectar con el servidor`));
  }
  deleteFavorite(id: any) {
    this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/Favorites/Delete?id=${id}`).subscribe(resp => {
      if (resp.isSuccessful) {
        this.messagesService.success('Favorito eliminado');
        this.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
      }
      else
        this.messagesService.error(`${resp.errorMessage}`);
    }, err => this.messagesService.error(`Error eliminando favorito: No se puedo conectar con el servidor`));
  }

}
